<template>
  <div>
    <points-balance-locks-table ref="pointsTable" />
  </div>
</template>

<script>
import PointsBalanceLocksTable from '@/modules/mobile/pontos/views/components/PointsBalanceLocksTable.vue'

export default {
  name: 'PointsBalanceLock',

  components: {
    PointsBalanceLocksTable,
  },
}
</script>
